import request from './index'

const http = {
	// 获取手机验证码
	async getCode(params) {
		return await request.post('/gateway/ApiService/api/v10/h5/auth/sms/getCode', params)
	},
	// 验证码登录
	async login(params) {
		return await request.post('/gateway/ApiService/api/v10/h5/auth/login', params)
	},
	// 获取用户订单信息
	async ordersList(params) {
		return await request.post('/gateway/ApiService/api/v10/h5/orders/list', params)
	},
	// 验证码身份证后三位
	async identityLast3(params) {
		return await request.post('/gateway/ApiService/api/v10/h5/auth/identityLast3', params)
	},
	// 联系我们
	async contactUs(params) {
		return await request.post('/gateway/ApiService/api/v10/h5/auth/contactUs', params)
	},
	// 结清证明下载
	async proofOfSettle(params) {
		return await request.post('/gateway/ApiService/api/v10/h5/download/proofOfSettle', params, {
			responseType: 'blob', // 必须设置
		})
	},
	// 埋点
	async websiteBrowsing(params) {
		return await request.post('/gateway/ApiService/api/v10/h5/frs/websiteBrowsing', params)
	},
}

export default http
